var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWithdrawal = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.334 21C20.334 21.8284 19.6624 22.5 18.834 22.5H12.834C12.0056 22.5 11.334 21.8284 11.334 21V12H20.334V21ZM15.834 14.25C15.4198 14.25 15.084 14.5858 15.084 15V17.6895L14.8643 17.4697L14.8076 17.418C14.5131 17.1777 14.0783 17.1952 13.8037 17.4697C13.5291 17.7443 13.5117 18.1791 13.752 18.4736L13.8037 18.5303L14.7734 19.5C15.3225 20.049 16.1911 20.0836 16.7803 19.6035L16.8945 19.5L17.8643 18.5303C18.1571 18.2374 18.1571 17.7626 17.8643 17.4697C17.5714 17.1769 17.0966 17.1769 16.8037 17.4697L16.584 17.6895V15C16.5839 14.5858 16.2482 14.25 15.834 14.25ZM20.334 9C21.9908 9 23.334 10.3431 23.334 12C23.334 13.259 22.5584 14.3372 21.459 14.7822V12C21.459 11.7016 21.3409 11.4151 21.1299 11.2041C20.9189 10.9931 20.6324 10.875 20.334 10.875H11.334C11.0356 10.875 10.7491 10.9931 10.5381 11.2041C10.3271 11.4151 10.209 11.7016 10.209 12V14.7822C9.10955 14.3372 8.33398 13.259 8.33398 12C8.33398 10.3431 9.67713 9 11.334 9H20.334Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWithdrawal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/withdrawal.62583df1d85e5a1a2005d2c6c819112a.svg";